<template>
	<div class="card-body">
		<form>
			<input-image label="image" v-model="image" />
			<input-text label="name" v-model="name" />
			<input-text label="gender" v-model="gender" />
			<input-text label="alignment" v-model="alignment" />
			<input-text label="theme" v-model="theme" />
			<input-text label="short_description" v-model="short_description" />
			<div class="form-group row">
				<label for="languages" class="col-sm-3 col-form-label">Languages</label>
				<div class="col-sm-9">
					<input-tag v-model="languages" id="languages" type="text" class="form-control" />
				</div>
			</div>
			<input-text label="speed" v-model="speed" />
			<input-text label="homeworld" v-model="homeworld" />
			<input-text label="deity" v-model="deity" />
			<input-text label="player" v-model="player" />
			<input-textarea label="long_description" v-model="long_description" />
		</form>
	</div>
</template>

<script>
function mapEverything( mod, properties ){
	var computed = {}
	properties.forEach(property => {
		computed[property] = {
			get () {
				return this.$store.getters[`${mod}/get`](property)
			},
			set ( value ){
				this.$store.commit(`${mod}/set`,{
					property,
					value
				})
			}
		}
	})
	return computed
}
import ucFirst from "@/mixins/ucfirst.js"
import InputImage from '@/components/InputImage.vue'
import InputTag from 'vue-input-tag'
import InputText from '@/components/InputText.vue'
import InputTextarea from '@/components/InputTextarea.vue'

export default {
	mixins: [
		ucFirst
	],
	components: {
		'input-tag': InputTag,
		...{
			InputImage,
			InputText,
			InputTextarea
		}
	},
	computed: {
		...mapEverything('character/bio',[
			'alignment',
			'name',
			'deity',
			'gender',
			'homeworld',
			'image',
			'languages',
			'long_description',
			'player',
			'short_description',
			'speed',
			'theme',
		]),
	},
}
</script>

<style scoped>

</style>